<template>
  <div class="live-video" v-loading="downLoading" :element-loading-text="loadingText">
    <div class="live">
      <el-row>
        <el-button round type="primary" @click="toLink($router,'/course/live-add',true)">新建直播</el-button>
        <div class="seach-list r iblock">
          <el-select class="input-v" v-model="search.status" @change="seachStatus">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="搜索课程"
            v-model="search.keywords"
            round
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div>
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list" v-loading="loading">
      <div class="mt20">
        <span class="little-title">全部课程（{{resultData.count}}）条</span>
      </div>
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column prop="course_name" label="直播名称"></el-table-column>
        <el-table-column prop="course_mode" label="直播类型">
          <template slot-scope="scope">
            <span v-show="scope.row.course_mode==1">语音直播</span>
            <span v-show="scope.row.course_mode==2">语音录播</span>
            <span v-show="scope.row.course_mode==3">视频直播</span>
            <span v-show="scope.row.course_mode==4">视频录播</span>
          </template>
        </el-table-column>
        <el-table-column prop="subscribe_num" label="订阅量"></el-table-column>
        <el-table-column prop="reward" label="打赏金额"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.state==-1">删除</span>
            <span v-show="scope.row.state==1">定时上架</span>
            <span v-show="scope.row.state==2">已上架</span>
            <span v-show="scope.row.state==3">下架/未上架</span>
          </template>
        </el-table-column>
        <el-table-column prop="published_at" label="上架时间"></el-table-column>
        <el-table-column prop="topic_name" label="关联专题"></el-table-column>
        <el-table-column label="操作" fixed="right"  min-width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="toLink($router,`/course/live-edit/${scope.row.course_id}`,true)"
            >编辑</el-button>
            <el-button
              v-if="scope.row.state==2||scope.row.state==1"
              type="text"
              size="mini"
              @click="downline(courseOffline(),{course_id:scope.row.course_id},initCouresList)"
            >下架</el-button>
            <el-button
              v-if="scope.row.state==3"
              type="text"
              size="mini"
              @click="online(courseOnline(),{course_id:scope.row.course_id},initCouresList)"
            >上架</el-button>
            <el-button type="text" size="mini" @click="openShare(scope.row.course_id,1)">分享</el-button>
            <el-button type="text" size="mini" @click="goLive(scope.row.course_id)">去直播</el-button>
            <el-dropdown class="dropdown-btn">
              <el-button type="text" size="small" class="ml10">
                更多
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button type="text" size="small" @click="exportAudio(scope.row.course_id)">导出音频</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    type="text"
                    size="small"
                    @click="guestSettings(scope.row.course_id)"
                  >嘉宾设置</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    type="text"
                    size="small"
                    @click="toLink($router,`/course/discuss/${scope.row.course_id}`,true)"
                  >查看讨论内容</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    type="text"
                    size="small"
                    @click="delItem(courseDel(),{course_id:scope.row.course_id},initCouresList)"
                  >删除</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="tc mt20">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
    </div>
    <!-- 修饰符传参，可以通过子组件的方法更新值的状态或者值 -->
    <template-guest
      :addCourseVisible.sync="addCourseVisible"
      @uploadStatus="uploadStatus"
      :course_id="course_id"
    ></template-guest>
    <!-- 分享 -->
    <share-dialog :shareVisible.sync="shareVisible" :share_info="share_info"></share-dialog>

    <!-- 去直播 -->
    <el-dialog title="PPT直播指南" :visible.sync="dialogGolive" width="30%" @close="clearLiveInfo">
        <p class="tc">邀请讲师后，讲师扫码登录即可进行PC直播</p>
        <p class="Z-name ft20 tc mt20">直播间地址</p> 
        <div class="mt10">
          <el-input
            placeholder
            v-model="live_href"
            class="input-with-select vm"
          >
            <el-button slot="append" @click="copyLink('http://www.baidi.com')">复制</el-button>
          </el-input>
        </div>
        <p class="Z-name tc ft20 mt20">小程序直播间二维码</p>
        <div class="flex-x-center mt10">
        <img :src="live_cord" alt="" class="iblock" width="150" height="150">
        </div>
          <div class="tc mt20">
            <el-button type="primary" size="mini" @click="downloadImg(live_cord,'小程序直播间二维码')">保存二维码</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
//导入接口api
import {
  _courseAdd,
  _courseEdit,
  _courseOnline,
  _courseSingTopic,
  _courseOffline,
  _courseDel,
  _getCourseList,
  _courseWait,
  _goLive
} from "@/api/course";

import util from "@/base/js/util";

import { _exportAudioFile } from "@/api/export-file";

//引入嘉宾设置
import Guest from "../play-template/guests-setting-dialog";

//引入混合mixins模式
import course_mixins from "../play-template/course-mixins";

export default {
  created() {
    this.initCouresList();
  },
  mixins: [course_mixins],
  data() {
    return {
      downLoading: false, //下载文件的loading
      loadingText: "",
      // 直播二维码
      live_cord:'',
      loading: false,
      //嘉宾弹框设置
      addCourseVisible: false,
      //去直播
      dialogGolive: false,
      live_href: "http://www.baidi.com",
      search: {
        keywords: "",
        status: "0",
        page:1,
        size:10,
      },
      course_id: null, //课程id
      shareInfo: {}, //分享的课程id
      options: [
        {
          label: "全部状态",
          value: "0"
        },
        {
          label: "待上架",
          value: "1"
        },
        {
          label: "已上架",
          value: "2"
        },
        {
          label: "已下架",
          value: "3"
        }
      ],
      resultData: [],
    };
  },
  components: {
    "template-guest": Guest
  },
  computed: {
    //获取user_id
  },
  methods: {
    //保存二维码
    downloadImg(url) {
      util.downloadIamge(url);
    },
    //加载列表
    initCouresList() {
      this.loading = true;
      _getCourseList({
        params: {
          page: this.search.page,
          size: this.search.size,
          keywords: this.search.keywords,
          state: this.search.status
        }
      }).then(res => {
        this.loading = false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //嘉宾设置成功后刷新页面
    uploadStatus(val) {
      if (val) {
        this.initCouresList();
      }
    },
    //去直播
    letGoLive(id) {
      _goLive({
        params: {
          course_id: id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.live_href = res.result.link;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    // 上架
    courseOnline() {
      return _courseOnline;
    },
    //下架
    courseOffline() {
      return _courseOffline;
    },
    //删除
    courseDel() {
      return _courseDel;
    },
    //状态查询信息
    seachStatus(val) {
      this.chearSearchState();
      this.initCouresList();
    },
    //关键字查询信息
    seachList() {
      this.chearSearchState();
      this.initCouresList();
    },
    goLive(id) {
      this.letGoLive(id);
      this.live_cord=`/admin/xcx/go-live?course_id=${id}`;
      this.dialogGolive = true;
    },
    //关闭时候清除数据
    clearLiveInfo(){
      this.live_cord='';
      this.live_href=''
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val;
      this.initCouresList();
    },
    //导出音频文件
    exportAudio(id) {
      _exportAudioFile({
        params: {
          course_id: id
        }
      }).then(res => {
        // console.log(res);
        if (res.resultCode == 1) {
          window.open(res.result.link, "_self");
        } else {
          this.loadingText = res.errorMsg;
          this.downLoading = true;
          setTimeout(() => {
            this.downLoading = false;
          }, 2000);
        }
      });
    },
    //嘉宾设置
    guestSettings(id) {
      this.course_id = id;
      this.addCourseVisible = true;
    },
    //复制链接
    copyLink(item) {
      let that = this;
      this.$copyText(this.live_href).then(
        function(e) {
          that.$message.success("复制成功");
        },
        function(e) {
          that.$message.error("复制失败");
        }
      );
    }
  }
};
</script>

<style scoped lang="less">
.live-video {
  min-height: 500px;
  overflow: hidden;
  .live {
    .seach-list {
      .input-v {
        // width: 160px;
        margin-left: 20px;
      }
      .input-sea {
        margin-left: 20px;
        width: 280px;
        border-radius: 5px;
      }
    }
  }
  .img_code {
    width: 150px;
    height: 150px;
    border: 1px solid #000;
    margin: 0 auto;
    margin-top: 20px;
    img {
      width: 100%;
    }
  }
}
</style>